module.exports = __webpack_public_path__ + "static/img/bg.87df9e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/news2/bg.jpg
// module id = a93w
// module chunks = 7